import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  InputBase,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import ExpandLessIcon from "@mui/icons-material/ExpandLess"; // Collapse Icon
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"; // Expand Icon;
import { Search } from "@mui/icons-material";
import { WSIcons } from "../../../commonFunctions/iIcons";
import { OverViewDeals } from "./OverViewDeals";
import { OverViewNotes } from "./OverViewNotes";
import { OverViewTask } from "./OverViewTask";
import { OverViewEmail } from "./OverViewEmail";
import { OverViewMeetings } from "./OverViewMeetings";
import { OverviewCalls } from "./OverviewCalls";


export const OverviewSection: React.FC<any> = React.memo((props) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Grid item container spacing={1}
      sx={{
        //  height: "500px", // Set the height you want for the section
        // overflowY: "auto", // Enable vertical scrolling
        borderRadius: 2,
        padding: 0,

      }}
    >
   
      <Grid item sm={12}>
        <OverViewDeals />
      </Grid>
      <Grid item sm={12} sx={{ marginTop: 2 }}>
        <OverviewCalls />
      </Grid>
      <Grid item sm={12} sx={{ marginTop: 2 }}>
        <OverViewMeetings />
      </Grid>

      <Grid item sm={12} sx={{ marginTop: 2 }}>
        <OverViewTask />
      </Grid>
      <Grid item sm={12} sx={{ marginTop: 2 }}>
        <OverViewNotes />
      </Grid>
      <Grid item sm={12} sx={{ marginTop: 2 }}>
        <OverViewEmail />
      </Grid>
      {/* <OverViewTasks /> */}
    </Grid>


  );
});
